export const SUBGRAPH_URL = 'https://api.thegraph.com/subgraphs/name/maksim-tolo/dragonereum';
export const SERVER_URL = 'https://api.dragonereum.io/';

export const DRAGON_SIZE = {
  WIDTH: 680,
  HEIGHT: 640,
};

export const SIZE_TYPES = {
  ORIGINAL: 'original',
  SMALL: 'small',
  SMALL_2X: 'small@2x',
};

export const SIZES = {
  [SIZE_TYPES.ORIGINAL]: {
    width: 680,
    height: 800,
  },
  [SIZE_TYPES.SMALL]: {
    width: 246,
    height: 289,
  },
  [SIZE_TYPES.SMALL_2X]: {
    width: 246 * 2,
    height: 289 * 2,
  },
};

export const SERVER_IMAGES_SIZE_MAP = {
  [SIZE_TYPES.ORIGINAL]: 'large',
  [SIZE_TYPES.SMALL_2X]: 'medium',
  [SIZE_TYPES.SMALL]: 'small',
};

export const DRAGONS_BASE_URL = 'textures/dragons';

export const PARTICLES = [
  'particle-0',
  'particle-1',
  'particle-2',
  'particle-3',
  'particle-4',
];

export const ANIMATIONS = {
  IDLE: 'idle',
  FLY: 'fly',
  SLEEP: 'sleep',
  IDLE_TO_SLEEP: 'idle_to_sleep',
  SLEEP_TO_IDLE: 'sleep_to_idle',
  IDLE_TO_FLY: 'idle_to_fly',
  FLY_TO_IDLE: 'fly_to_idle',
  ATTACK_CLOSE: 'attack_close',
  ATTACK_FAR: 'attack_far',
  FLY_TO_DEFENCE: 'fly_to_defence',
  DEFENCE_TO_FLY: 'defence_to_fly',
  DEFENCE_IDLE: 'defence_idle',
  FLY_DAMAGE: 'fly_damage',
  SPELL_ATTACK: 'spell_attack',
  SPELL_DEFENCE: 'spell_defence',
  WIN: 'win',
  DEATH: 'death',
  DEFENCE_DAMAGE: 'defence_damage',
};

export const RACES = [{
  id: 0,
  color: '#3eb3e4',
  name: 'water',
  types: [
    'sewage',
    'aqueous',
    'ice',
    'swamp',
    'slime',
    'oil',
    'poison',
    'abyss',
    'tritium',
    'quicksilver',
  ],
}, {
  id: 1,
  color: '#a90001',
  name: 'fire',
  types: [
    'ashen',
    'charred',
    'flaming',
    'molten',
    'sparkling',
    'solar',
    'firework',
    'laser',
    'plasma',
    'volcanic',
  ],
}, {
  id: 2,
  color: '#8a9cbc',
  name: 'air',
  types: [
    'miasma',
    'wind',
    'smoke',
    'nebulous',
    'whirlwind',
    'bubble',
    'jet',
    'dust',
    'cyclone',
    'cosmic',
  ],
}, {
  id: 3,
  color: '#d07920',
  name: 'earth',
  types: [
    'mud',
    'stone',
    'copper',
    'malachite',
    'sand',
    'steel',
    'marble',
    'platinum',
    'obsidian',
    'uranium',
  ],
}, {
  id: 4,
  color: '#292929',
  name: 'magic',
  types: [
    'cursed',
    'hypnotic',
    'alchemical',
    'twilight',
    'arcane',
    'voodoo',
    'necromantic',
    'enchanted',
    'divine',
    'demonic',
  ],
}, {
  id: 5,
  color: '#ffe66d',
  name: 'electric',
}, {
  id: 6,
  color: '#f7fff7',
  name: 'arcane',
}, {
  id: 7,
  color: '#4f1271',
  name: 'ethereal',
}, {
  id: 8,
  color: '#c8c6d7',
  name: 'infinite',
}, {
  id: 9,
  color: '#bfacc8',
  name: 'time',
}, {
  id: 10,
  color: '#4a4063',
  name: 'twilight',
}];

export const DRAGON_DETAILS_QUERY = `
query Dragon($id: ID!) {
  dragon(id: $id) {
    types
    genome
    birthDay
    generation
    coolness
    level
  }
}
`;
